module.exports = __webpack_public_path__ + "media/plaintiffs/hero-ee2a51e1.jpg";